import { Box, BoxProps, Divider } from '@mui/material';
import React from 'react';

export const MainMenuDivider: React.FC<BoxProps> = ({ sx, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box sx={{ borderRight: '1px solid #DEDEDE', px: '8px', pb: '8px', pt: '24px', ...sx }} {...props}>
    <Divider />
  </Box>
);
